import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';


@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    NzTypographyModule,
    NzLayoutModule,
    NzMenuModule,
    NzDrawerModule,
    NzGridModule,
		NzBreadCrumbModule,
		NzDividerModule,
		NzIconModule,
		NzFormModule,
		NzInputModule,
		NzAutocompleteModule,
    NzCheckboxModule,
    NzRadioModule,
    NzSwitchModule,
		NzDatePickerModule,
		NzSelectModule,
		NzUploadModule,
		NzButtonModule,
    NzDropDownModule,
    NzCalendarModule,
		NzListModule,
		NzTableModule,
		NzTabsModule,
		NzToolTipModule,
    NzPopoverModule,
		NzCarouselModule,
		NzModalModule,
    NzMessageModule,
    NzEmptyModule,
    NzTreeModule,
    NzCollapseModule
  ],
  exports:[
    NzTypographyModule,
    NzLayoutModule,
    NzMenuModule,
    NzDrawerModule,
    NzGridModule,
		NzBreadCrumbModule,
		NzDividerModule,
		NzIconModule,
		NzFormModule,
		NzInputModule,
		NzAutocompleteModule,
    NzCheckboxModule,
    NzRadioModule,
    NzSwitchModule,
		NzDatePickerModule,
		NzSelectModule,
		NzUploadModule,
		NzButtonModule,
    NzDropDownModule,
    NzCalendarModule,
		NzListModule,
		NzTableModule,
		NzTabsModule,
		NzToolTipModule,
    NzPopoverModule,
		NzCarouselModule,
		NzModalModule,
    NzMessageModule,
    NzEmptyModule,
    NzTreeModule,
    NzCollapseModule
  ]
})
export class NgZorroModule { }
